
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { DataOptions, DataTableHeader } from "vuetify";
import Themeable from "vuetify/lib/mixins/themeable";
import {
  ActionLogRepositoryInterface,
  FilteringOptions,
  SearchActionLogsOptions,
  SearchActionLogsResponse,
} from '@/services/Action-Logs/interfaces/index';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'actionLogRepository',
  ],
  components: {},
})
export default class AllActionLogs extends Vue {
  public actionLogRepository!: ActionLogRepositoryInterface;

  public loading: boolean = false;

  public tableHeaders: DataTableHeader[] = [
    { text: "Timestamp", value: "timestampMilli", sortable: false },
    { text: "Service ID", value: "serviceId", sortable: false },
    { text: "Session ID", value: "sessionId", sortable: false },
    { text: "Type", value: "logType", sortable: false },
    { text: "User", value: "user", sortable: false },
    { text: "Action", value: "action", sortable: false },
    { text: "Message", value: "message", sortable: false },
    { text: '', value: 'data-table-expand' },
  ] as const;

  public data: SearchActionLogsResponse = {
    data: [],
    take: 15,
    skip: 0,
    count: 0,
  };

  public dataOptions: DataOptions = {
    itemsPerPage: 15,
    page: 1,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
  };

  public async changePage(): Promise<void> {
    await this.search();
  }

  public options: FilteringOptions = {};

  public async search(opts?: FilteringOptions): Promise<void> {
    this.loading = true;

    if (opts) {
      this.options = {
        ...this.options,
        ...opts,
      }
      this.dataOptions.page = 1;
    }

    try {
      this.data = await this.actionLogRepository.search({
        ...this.options,
        ...{fromMilli: this.options.fromMilli ? new Date(this.options.fromMilli).valueOf() : undefined},
        ...{toMilli: this.options.toMilli ? new Date(this.options.toMilli).valueOf() : undefined},
        ...dataOptionsToSearchOptions(this.dataOptions),
      });
    } catch (error) {
      this.handleError(error);
    } finally {
      this.loading = false;
    }
  }

  public async created(): Promise<void> {
    await this.search();
  }

  public async initialize(): Promise<void> {
    await this.search();
  }

  private handleError(error: unknown): void {
    const defaultErrorMessage = 'An error occurred' as const;

    if(isAxiosError(error)) {
      this.$errorDialog.show(error.response?.data?.message || defaultErrorMessage);
    } else if (error instanceof Error) {
      this.$errorDialog.show(error.message);
    } else {
      this.$errorDialog.show(defaultErrorMessage);
    }
  }
}

function dataOptionsToSearchOptions(dataOptions: DataOptions): SearchActionLogsOptions {
  let skip: number | undefined = (dataOptions.page - 1) * dataOptions.itemsPerPage
  if (skip <= 0) {
    skip = undefined
  }

  return {
    skip: skip,
    take: dataOptions.itemsPerPage,
  };
}

function isAxiosError(error: unknown): error is AxiosError {
  return (error as AxiosError).isAxiosError !== undefined;
}
